module.exports = __webpack_public_path__ + "static/img/persimmon.af1a251.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/persimmon.jpg
// module id = jcFf
// module chunks = 1